// extracted by mini-css-extract-plugin
export default {"container":"PageHeaderTitle_container__6h8cj","title":"PageHeaderTitle_title__4WpNm","subtitle":"PageHeaderTitle_subtitle__dUKK6"};